module.exports = __webpack_public_path__ + "img/IconSkinConsultation.c78b15d1.svg";